import React from 'react'
import styled, { css } from 'styled-components'
import { array, bool } from 'prop-types'

import { media, mediaDown } from 'styles/media'
import { white } from 'styles/colors'
import { fontWeights, fontSizes } from 'styles/typography'
import { animationTime, animationCurve, cover } from 'styles/global'
import * as spacing from 'styles/spacing'

import Button from 'components/button/Button'

const Container = styled.div`
  text-align: center;
  position: relative;
  width: 100%;
  padding: 0 2vw;

  ${props =>
    props.unavailable &&
    css`
      opacity: 0.4;
    `}
`

const FigureWrap = styled.div`
  position: relative;
  margin-left: auto;
  margin-right: auto;
  opacity: 0.4;
  transition: transform ${animationTime} ${animationCurve}, opacity ${animationTime} ${animationCurve};

  .slick-center & {
    opacity: 1;
    z-index: 10;
  }

  &:after {
    content: '';
    display: block;
    padding-bottom: 420%;
  }
`

const Figure = styled.img`
  object-fit: cover;
  z-index: 10;
  transition: transform ${animationTime} ${animationCurve}, opacity ${animationTime} ${animationCurve};
  ${cover('absolute')};

  .slick-center & {
    transform: translateY(-25%);
  }
`

const ButtonWrap = styled.div`
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  white-space: nowrap;
  width: 170px;
  opacity: 0;
  transition: transform ${animationTime} ${animationCurve}, opacity ${animationTime} ${animationCurve};

  .slick-center & {
    z-index: 20;
  }

  ${mediaDown.small`
    margin-top: ${spacing.medium};
  `};

  ${media.medium`
    width: 210px;
  `};

  ${media.large`
    width: 250px;
  `};

  .slick-center & {
    opacity: 1;
  }
`

const BuyButton = styled(Button)`
  width: 100%;
`

const Meta = styled.div`
  position: absolute;
  z-index: 10;
  opacity: 0;
  transition: transform ${animationTime} ${animationCurve}, opacity ${animationTime} ${animationCurve};
  width: 180px;
  left: 50%;
  top: 75%;
  transform: translateX(-50%);
  margin-bottom: 50%;

  ${media.small`
    margin-bottom: 60%;
  `};

  ${media.medium`
    margin-bottom: 65%;
    top: 74%;
  `};

  ${media.large`
    top: 73%;
  `};

  .slick-center & {
    opacity: 1;
  }
`

const Collection = styled.span`
  display: block;
  color: ${white};
  font-weight: ${fontWeights.medium};
  font-size: ${fontSizes.tiny};
  text-transform: uppercase;
  margin-bottom: ${spacing.tiny};
  text-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
`

const Name = styled.span`
  display: block;
  color: ${white};
  text-transform: uppercase;
  font-weight: ${fontWeights.medium};
  letter-spacing: 0.15em;
  text-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
`

const CubeWrap = styled.div`
  position: absolute;
  bottom: -45%;
  left: 50%;
  width: 320%;
  opacity: 0;
  transform: translateX(-50%);
  transition: transform ${animationTime} ${animationCurve}, opacity ${animationTime} ${animationCurve};

  ${media.small`
    bottom: -30%;
    left: 50%;
    width: 260%;
  `};

  &:after {
    content: '';
    display: block;
    padding-bottom: 122%;
    width: 100%;
  }

  .slick-center & {
    opacity: 1;
  }
`

const Cube = styled.img`
  ${cover('absolute')};
  object-fit: cover;
  max-width: none;
`

const Skin = ({ skin, available = true }) => {
  return (
    <Container unavailable={!available}>
      <FigureWrap>
        <Figure src={skin.images[0].originalSrc} alt={`${skin.title} skin design`} />
        <CubeWrap>
          <Cube src={`${process.env.BASE_PATH}/images/skins/cubes/${skin.handle}.png`} />
        </CubeWrap>
        <Meta>
          <Collection>{skin.tags[0]}</Collection>
          <Name>{skin.title}</Name>
        </Meta>
      </FigureWrap>

      <ButtonWrap>
        <BuyButton
          to={`/buy-online/vype-epod-skins/${skin.handle}/`}
          theme="custom"
          customColor={white}
          variant="outline"
          size="large"
          disabled={!available}
        >
          {available ? 'Buy now' : 'Unavailable'}
        </BuyButton>
      </ButtonWrap>

      <div>&nbsp;</div>
    </Container>
  )
}

Skin.propTypes = {
  skin: array.isRequired,
  unavailable: bool
}

export default Skin
